import Skeleton from '@mui/material/Skeleton';
import placeHolderIcon from '../../assets/img/AppIcon1.svg'

interface EmptyBoxProps {
    styles?: React.CSSProperties
    label?: string
    loading?: boolean,
    width?: string,
    byError?: boolean
}

function EmptyBox({ label = "Sin elementos", loading = false, byError, width = '100%', styles }: EmptyBoxProps) {
    return (
        <div className='d-flex empty-box' style={{ width, ...styles }}>
            {loading ? <Skeleton title="skeleton" variant="rectangular" className='m-auto' width="100%" height="10rem" /> : <div className='m-auto'>
                <img src={placeHolderIcon} alt="Sin elementos" className={byError ? 'alert-error' : ''} />
                <h4 className='empty-box-title gray'>{label}</h4>
            </div>}

        </div>
    )
}

export default EmptyBox